<template>
	<div class="fromComm">
		<div style="display: flex;flex-wrap: wrap;align-content: flex-start;">
			<div v-for="(item,index) of FromArr" :key="index"
				:style="[ {marginLeft: `${item.hidden ? 0 : item.marginLeft }px`},{marginTop: `${ item.marginTop }px`} ]"
				style="margin-left: 20px;">
				<template v-if="!item.hidden">
					<!-- 文本框 -->
					<template v-if="item.inputtype == `input`">
						<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}

								<!-- 是否必填 -->
							</div>
							<input v-model="item.modelvalue" :type="item.types" @change="events(item.event,index)"
								:class="[item.redborder?'redborder':'']" @focus="events(item.focus)" placeholder-Style
								:placeholder="item.placeholder"
								:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
								:disabled="item.disabled" clearable />
						</form>
					</template>
					<!-- 多行文本框 -->
					<template v-if="item.inputtype == `textarea`">
						<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
						<form style="display: flex;align-items:flex-start;" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}

								<!-- 是否必填 -->
							</div>
							<textarea v-model="item.modelvalue" @change="events(item.event,index)" :rows="item.rows"
								:class="[item.redborder?'redborder':'']" @focus="events(item.focus)" placeholder-Style
								:placeholder="item.placeholder"
								:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
								:disabled="item.disabled" clearable />
						</form>
					</template>
					<!-- 下拉框 -->
					<template v-if="item.inputtype == `select`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
								{{ item.title }}
							</div>
							<!-- 是否必填 -->
							<el-select v-model="item.modelvalue" :multiple="item.multiple"
								:class="[item.redborder?'redborder':'']" :collapse-tags="item.collapseTags" clearable
								:placeholder="item.placeholder" @change="events(item.event,index)"
								:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
								:disabled="item.disabled">
								<el-checkbox v-model="item.checkedSelect" @change="selectAll(item.event,index)"
									v-if="item.SelectType=='SelectAll'" style="margin-left: 20px;">{{ item.AllName }}
								</el-checkbox>
								<el-option v-for="(items,index) in item.options" :key="index" :label="items.value"
									:value="items.key" placeholder-Style :placeholder="item.placeholder">
								</el-option>
							</el-select>
						</form>
					</template>
					<!-- 下拉框多个下拉框自定义 -->
					<template v-if="item.inputtype == `selects`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<!-- 是否必填 -->

							<div v-for="(itemSA , indexSA) of item.selectArr" :key="indexSA" class="selectSA">
								<el-select v-model="itemSA.modelvalue" :multiple="itemSA.multiple"
									:class="[item.redborder?'redborder':'']" :collapse-tags="itemSA.collapseTags"
									clearable :placeholder="itemSA.placeholder" @change="events(itemSA.event)"
									:style="[{ width: `${ itemSA.width }px` },{ height: `${ itemSA.height }px` }]"
									:disabled="itemSA.disabled">
									<el-checkbox v-model="itemSA.checkedSelect" @change='selectAll'
										v-if="itemSA.SelectType=='SelectAll'" style="margin-left: 20px;">
										{{ itemSA.AllName }}
									</el-checkbox>
									<el-option v-for="items in itemSA.options" :key="items.key" :label="items.value"
										:value="items.key" placeholder-Style :placeholder="itemSA.placeholder">
									</el-option>
								</el-select>
								<div class="line"></div>
							</div>
						</form>
					</template>
					<!-- 下拉多选框 /远程搜索-->
					<template v-if="item.inputtype == `selectMultiple`">
						<form style="display: flex;align-items: center;" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
								{{ item.title }}
							</div>
							<el-tooltip :content="item.tooltipText" placement="top" :manual="true" v-model="item.showTooltip" :disabled="!item.tooltipText">
								<el-select v-model="item.modelvalue" filterable multiple remote reserve-keyword clearable
									collapse-tags :remote-method="(val)=>remoteMethod(val,item.remoteMethod)"
									:class="[item.redborder?'redborder':'']" :loading="item.loading"
									:placeholder="item.placeholder" @remove-tag='removeTag'
									@change="events(item.event,index)"
									@focus="handleSelectFocus(item)" @blur="handleSelectBlur(item)"
									:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
									:disabled="item.disabled">
									<!-- <el-option label='全选' value='全选' @click.native='selectAll'></el-option> -->
									<el-option v-for="items in item.options" :key="items.value" :label="items.label"
										:value="items.value" @change="events(item.event,index)" placeholder-Style
										:placeholder="item.placeholder">
									</el-option>
								</el-select>
							</el-tooltip>
						</form>
					</template>
					<!-- 下拉单选框 /远程搜索-->
					<template v-if="item.inputtype == `selectSingle`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
								{{ item.title }}
							</div>
							<el-select v-model="item.modelvalue" filterable remote reserve-keyword clearable
								:remote-method="(val)=>remoteMethod(val,item.remoteMethod)" :loading="item.loading"
								:placeholder="item.placeholder" @remove-tag='removeTag'
								:class="[item.redborder?'redborder':'']" @change="events(item.event,index)"
								:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
								:disabled="item.disabled">
								<!-- <el-option label='全选' value='全选' @click.native='selectAll'></el-option> -->
								<el-option v-for="items in item.options" :key="items.value" :label="items.label"
									:value="items.value" @change="events(item.event,index)" placeholder-Style
									:placeholder="item.placeholder">
								</el-option>
							</el-select>
						</form>
					</template>

					<!-- 日期选择框 -->
					<template v-if="item.inputtype == `date`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-date-picker :class="[item.redborder?'redborder':'']"
								:style="[ { width: `${ item.width }px` } , { height: `${ item.height }px`}  ]"
								v-model="item.modelvalue" value-format="yyyy-MM-dd" :type="item.types"
								:placeholder="item.placeholder" @input="datetimeChange" :disabled="item.disabled">
							</el-date-picker>
						</form>
					</template>

					<!-- 日期选择框 -->
					<template v-if="item.inputtype == `monthrange`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-date-picker :class="[item.redborder?'redborder':'']"
								:style="[ { width: `${ item.width }px` } , { height: `${ item.height }px`}  ]"
								v-model="item.modelvalue" value-format="yyyy-MM" type="monthrange" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" @input="datetimeChange"
								:disabled="item.disabled" :editable="false">
							</el-date-picker>
						</form>
					</template>


					<!-- 年份选择框 -->
					<template v-if="item.inputtype == `year`">
						<form style="display: inline-block" v-if="item.inputflag">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-date-picker :class="[item.redborder?'redborder':'']"
								:style="[ { width: `${ item.width }px` } , { height: `${ item.height }px`}  ]"
								v-model="item.modelvalue" value-format="yyyy" type="year"
								:placeholder="item.placeholder" @input="datetimeChange" :disabled="item.disabled">
							</el-date-picker>
						</form>
					</template>
					<!-- 日期选择框(区间) -->
					<template v-if="item.inputtype == `dateSection`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
								{{ item.title }}
							</div>
							<el-date-picker :picker-options="item.pickerOptionsFlagStart == 'Now' ? dateOptionNow 
			    : item.pickerOptionsFlagStart == 'Year' ? dateOptionYear 
			    : item.pickerOptionsFlagStart == 'Month' ? dateOptionMonth : dateOption"
								:style="[ { width: `${ item.widthLeft }px` }, { height: `${ item.heightLeft }px` }  ]"
								v-model="item.StartTime" :value-format="item.types=='month'?'yyyy-MM':'yyyy-MM-dd'"
								:type="item.types" :placeholder="item.placeholder" @input="datetimeChange"
								:disabled="item.Startdisabled">
							</el-date-picker>
							<div style="display:inline-block;margin-left: 10px;margin-right: 10px;">-</div>
							<el-date-picker :picker-options="item.pickerOptionsFlagEnd == 'Now' ? dateOptionNow 
			    : item.pickerOptionsFlagEnd == 'Year' ? dateOptionYear
			    : item.pickerOptionsFlagStart == 'Month' ? dateOptionMonth : dateOption"
								:style="[ { width: `${ item.widthRight }px` }, { height: `${ item.heightRight }px` }  ]"
								v-model="item.EndTime" :value-format="item.types=='month'?'yyyy-MM':'yyyy-MM-dd'"
								:type="item.types" :placeholder="item.placeholder" @input="datetimeChange"
								:disabled="item.EndDisabled">
							</el-date-picker>
						</form>
					</template>

					<!-- 月份选择框(区间) -->
					<template v-if="item.inputtype == `monthSection`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
								{{ item.title }}
							</div>
							<el-select v-model="item.StartTime"
								:style="[ { width: `${ item.widthLeft }px` }, { height: `${ item.heightLeft }px` }  ]"
								:placeholder="item.placeholder">
								<el-option v-for="it in 12" :key="it" :label="it" :value="it" />
							</el-select>
							<div style="display:inline-block;margin-left: 10px;margin-right: 10px;">-</div>
							<el-select v-model="item.EndTime"
								:style="[ { width: `${ item.widthLeft }px` }, { height: `${ item.heightLeft }px` }  ]"
								:placeholder="item.placeholder">
								<el-option v-for="it in 12" :key="it" :label="it" :value="it" />
							</el-select>
						</form>
					</template>

					<!-- 复选框单选 -->
					<template v-if="item.inputtype == `checkedD`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-checkbox v-model="item.checked" @change="events(item.event,index)"
								:disabled="item.disabled">
							</el-checkbox>
						</form>
					</template>
					<!-- 复选框单选 -->
					<template v-if="item.inputtype == `checkebox`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-checkbox v-model="item.modelvalue" true-label="1" false-label="0"
								:disabled="item.disabled"></el-checkbox>
						</form>
					</template>
					<!-- 单选框选择 -->
					<template v-if="item.inputtype == `radio`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-radio v-for="(item1,index1) in item.options" :key="index1" v-model="item.modelvalue"
								:label="item1.value" :disabled="item.disabled">{{item1.label}}</el-radio>
						</form>
					</template>
					<!-- 层级下拉框 -->
					<template v-if="item.inputtype == `cascader`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot></slot>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-cascader class="selecter"
								:style="[ { width: `${ item.width }px` } , { height: `${ item.height }px`}  ]"
								:show-all-levels="false" :props="item.props" v-model="item.modelvalue"
								:options="item.options" :disabled="item.disabled"></el-cascader>
						</form>
					</template>
					<!-- 计数器 -->
					<template v-if="item.inputtype == `NumberInput`">
						<form style="display: inline-block" v-if="item.inputflag" class="dateSection">
							<div
								:style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]">
								<slot> </slot>
								<div v-show="false">
									{{item.modelValue}}
								</div>
								{{ item.title }}<span style="color: #E71D43;" v-if="item.desc">{{ item.desc }}</span>
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<el-input-number :class="[item.redborder?'redborder':'']" v-model="item.modelValue"
								:precision="item.precision" size="small" :step="item.step?item.step:1"
								controls-position="right" :min="item.min" :max="item.max"
								@change="events(item.event,index)" placeholder-Style :placeholder="item.placeholder"
								:style="[{ width: `${ item.width }px` },{ height: `${ item.height }px` }]"
								:disabled="item.disabled"></el-input-number>
						</form>
					</template>
					<!-- 计数器 NumberInputs-->
					<template v-if="item.inputtype == `NumberInputs`">
						<form style="display: inline-block;position: relative;" v-if="item.inputflag"
							class="dateSection">
							<div :style="[{fontSize: `${ item.fontSize }px` },{ color: `${ item.color }` },{ height: `${ item.lableheight }px` },{ width: `${ item.lablewidth }px` },{display: `${ item.displayVal }`} , {fontWeight:  `${ item.fontWeightVal }`}]"
								style=" font-weight: 500;">
								<slot> </slot>
								<div v-show="false">
									{{item.modelValue}}
								</div>
								{{ item.title }}
								<span style="color: #E71D43;  position: relative;top: 2px;" v-if="item.X">*</span>
							</div>
							<div v-for="(items , indexs) of item.options" :key="indexs" class="numberOptions">
								<el-input-number :class="[item.redborder?'redborder':'']" v-model="items.modelValue"
									:precision="items.precision" size="small" controls-position="right" :min="items.min"
									:max="items.max" @change="events(items.event)" placeholder-Style
									:placeholder="items.placeholder"
									:style="[{ width: `${ items.width }px` },{ height: `${ items.height }px` }]"
									:disabled="items.disabled">
								</el-input-number>
								<div class="NumberLine"></div>
							</div>
						</form>
					</template>
					<template v-if="item.inputtype == 'cascaderNodeParent'">
						<el-cascader :style="{ width: `${ item.width }px` }" :options="item.options" :props="{
			      emitPath: false,
			      checkStrictly: true,
			      multiple: false,
			      value: 'NodeID',
			      label: 'NodeName',
			      children: 'Nodes',
			    }" :placeholder="item.placeholder" v-model="item.modelvalue" class="elselect" :show-all-levels="false"
							:disabled="item.disabled">
						</el-cascader>
					</template>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			// 文本框数组
			FromArr: {
				type: Array
			},
			dateIcon: {
				type: String,
			},

		},
		data() {
			return {
				dateOptionNow: {
					disabledDate: (time) => {
						return time >= Date.now();
					}
				},
				// 控制年不能大约当前年
				dateOptionYear: {
					disabledDate: (time) => {
						let year = new Date().getFullYear()
						return time.getFullYear() > year;
					}
				},
				// 控制月份不能大约当前月份
				dateOptionMonth: {
					disabledDate: (time) => {
						let Time = '';
						this.FromArr.forEach((item, indedx) => {
							if (item.inputtype == "dateSection") {
								if (item.types == "month") {
									Time = item.StartTime;
								}
							}
						})
						return time.getTime() < new Date(Time).getTime() || time.getTime() > Date.now();
					}
				},
				dateOption: {
					disabledDate: (time) => {
						return '';

					}
				},
			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			handleSelectFocus(item) {
				if (item.tooltipText) {
					this.$set(item, 'showTooltip', true);
				}
			},
			handleSelectBlur(item) {
				if (item.tooltipText) {
					this.$set(item, 'showTooltip', false);
				}
			},
			events(e, i) {
				this.$emit("selectChange", i);
				this.$forceUpdate();
				try {
					this.$options.methods[e].call(this, e, i)

					this.FromArr.forEach((item, index) => {
						if (item.selectFlag) {
							item.selectArr.forEach((itemArr, indexArr) => {
								if (itemArr.SelectType == 'SelectAll') {
									if (itemArr.modelvalue.length != itemArr.options.length) {
										itemArr.checkedSelect = false
									} else {
										itemArr.checkedSelect = true
									}
								}
							})
						} else {
							if (item.SelectType == 'SelectAll') {
								if (item.modelvalue.length != item.options.length) {
									item.checkedSelect = false
								} else {
									item.checkedSelect = true
								}
							}
						}
						// SelectType == 'SelectAll' 才可以全选的

					})
				} catch (e) {
					// //console.log("异常",e)
				}
			},

			selectAll(e, i) {
				console.log(this.FromArr);

				// 多选框全选操作
				this.FromArr.forEach((item, index) => {
					if (item.selectFlag) {
						console.log(666);
						item.selectArr.forEach((itemArr, indexArr) => {
							if (itemArr.SelectType == 'SelectAll') {
								if (itemArr.checkedSelect) {
									itemArr.options.forEach((items, indexs) => {
										if (!itemArr.modelvalue.includes(items.key)) {
											itemArr.modelvalue.push(items.key)
										}
									})
									//console.log(itemArr);
								} else {
									itemArr.modelvalue = []
								}
							}
						})
					} else {
						console.log(7777);
						if (item.SelectType == 'SelectAll' && index === i) {
							if (item.checkedSelect) {
								item.options.forEach((items, indexs) => {
									if (!item.modelvalue.includes(items.key)) {
										item.modelvalue.push(items.key)
									}
								})
								//console.log(item);
							} else {
								item.modelvalue = []
							}
						}
					}

				})
				this.$emit("selectChange", i);
			},

			// 多选远程搜索
			remoteMethod(qurey, parsign) {
				let param = {
					qurey,
					parsign
				}
				// this.$forceUpdate()
				this.$emit('remoteMethod', param)
			},
			// 日期框选择刷新选择框的值
			datetimeChange(e) {
				let _this = this
				_this.$forceUpdate();
			},
			InforSelectChange(e) {
				this.$emit('InforSelectChange', this)
			},
			invClassChange(e) {
				this.$emit('invClassChange', this)
			},
			level15Change(e) {
				this.$emit('level15Change', this)
			},
			AuthorizedDealerChange(e) {
				this.$emit('AuthorizedDealerChange', this)
			},
			OnceYearChange(e) {
				this.$emit('OnceYearChange', this)
			},
			YearChange(e) {
				this.$emit('YearChange', this)
			},
			YearQuotaChange() {
				// this.$forceUpdate()
				this.$emit('YearQuotaChange', this)
			},
			AuthorizedTransChange(e) {
				this.$emit('AuthorizedTransChange', this)
			},
			QuarterChange(t, e) {
				console.log(111111, e);
				this.$emit('QuarterChange', e);
			},
			FirstQuarterChange(e) {
				this.$emit('FirstQuarterChange', this)
			},
			SecondQuarterChange(e) {
				this.$emit('SecondQuarterChange', this)
			},
			ThirdQuarterChange(e) {
				this.$emit('ThirdQuarterChange', this)
			},
			FourthQuarterChange(e) {
				this.$emit('FourthQuarterChange', this)
			},
			AuthorizedProduct(e) {
				this.$forceUpdate()
				this.$emit('AuthorizedProduct', this)
			},
			LargeArea(e) {
				this.$forceUpdate()
				this.$emit('LargeArea', this)
			},
			ThirdDealerChange(e) {
				this.$forceUpdate()
				this.$emit('ThirdDealerChange', this)
			},
			QuarterOne(e) {
				this.$forceUpdate()
				this.$emit('QuarterOne', this)
			},
			QuarterTow(e) {
				this.$forceUpdate()
				this.$emit('QuarterTow', this)
			},
			Province(e) {
				this.$emit('Province', this)
			},
			City(e) {
				this.$emit('City', this)
			},
			District(e) {
				this.$emit('District', this)
			},
			distributorChange(e) {
				this.$emit('distributorChange', this)
			},


			// 全选
			// selectAll() {
			//   this.$emit("selectAll")
			// },
			// 删除全选
			removeTag(val) {
				this.$emit("removeTag", val)
			}
		},
		computed: {
			date() {
				return {
					'--dateIcon': this.dateIcon
				}
			}
		},
		watch: {
			inputdata(newdata) {
				this.modelvalue = newdata
			},
			modelvalue(val) {
				this.$emit("change", val);
			},
		},
	}
</script>
<style scoped lang='less'>
	.fromComm {
		user-select: none;
	}

	.selectSA {
		display: inline-block;
		position: relative;

		.line {
			width: 16px;
			height: 2px;
			background: #e5e6eb;
			border-radius: 0px 0px 0px 0px;
			position: absolute;
			top: 50%;
			left: 120%;
		}
	}

	.selectSA:nth-child(n + 3) {
		display: inline-block;
		position: relative;
		margin-left: 100px;
	}

	.selectSA:nth-last-child(1) {
		.line {
			background: #ffffff;
		}
	}

	.el-cascader-panel .el-radio {
		width: 100%;
		height: 100%;
		z-index: 10;
		position: absolute;
		top: 10px;
		right: 10px;
	}

	.el-cascader-panel .el-radio__input {
		visibility: hidden;
	}

	.el-cascader-panel .el-cascader-node__postfix {
		top: 10px;
	}

	.el-cascader-menu {
		height: 100%;
		width: 230px;
	}

	// 调整ElementUI日期框的样式
	// 整个框的大小
	/deep/.el-input__inner {
		border: 1px solid #e6e8eb;
		background-color: #FFFFFF;
		font-size: 14px;
		color: #16181a;
		border-radius: 2px;
		height: 32px;
		padding-left: 10px;
		// margin-top: 6px;
	}

	/deep/.el-input__prefix .el-input__icon.el-icon-date {
		position: relative;
		right: 10px;
	}

	// 框内Icon的位置
	/deep/.el-input__prefix {
		position: absolute;
		right: 5px;
		left: auto;
		transition: all 0.3s;
	}

	/deep/.el-date-editor:hover .el-input__prefix {
		display: none;
	}

	/deep/.el-select-dropdown__item.selected {
		color: #e71d43 !important;
	}

	/deep/.el-picker-panel__content .el-date-table .available.current:not(.disabled) span {
		background-color: #16181a !important;
	}

	/deep/.el-input__suffix .el-input__suffix-inner .el-select__caret.el-input__icon.el-icon-arrow-up {
		position: absolute;
		right: 0;
		top: 5px;
	}

	/deep/.el-input__suffix-inner .el-select__caret.el-input__icon.el-icon-arrow-up::before {}

	/* /deep/.el-select__tags .el-select__input {
		margin-top: 10px !important;
	} */

	/deep/.el-select .el-input.is-focus .el-input__inner {
		border-color: #e71d43;
	}

	/deep/.el-select__caret.el-input__icon.el-icon-circle-close {
		position: absolute;
		right: 12px;
		top: 2px;
	}

	/deep/.el-input.el-input--suffix .el-input__inner {
		// max-height: 32px !important;
	}

	/deep/.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(1) {
		position: relative;
		top: 0px;
		background: #ffffff;
		border-radius: 1px;
		border: 1px solid #e6e8eb;
		font-size: 14px;
		color: #16181a;
		max-width: 100px;
		min-width: 20px;
	}

	/deep/.el-tag.el-tag--info.el-tag--small.el-tag--light {
		position: relative;
		top: 0px;
		background: #ffffff;
		border-radius: 1px;
		border: 1px solid #e6e8eb;
		font-size: 14px;
		color: #16181a;
	}

	/deep/.el-select .el-tag__close.el-icon-close {
		background-color: #ffffff;
	}

	/deep/.el-select .el-tag__close.el-icon-close:hover {
		background-color: #ffffff;
	}

	/deep/.el-select .el-tag__close.el-icon-close:hover::before {
		background-color: #ffffff;
	}

	/deep/.el-select .el-tag__close.el-icon-close::before {
		content: "";
		position: absolute;
		width: 20px;
		height: 20px;
		background: url("../../../../../../assets/channel/del.png") no-repeat -5px -2px;
		background-size: 100%;
	}

	/deep/.el-date-table td.current:not(.disabled) span {
		background-color: rgb(250, 12, 12) !important;
	}

	/deep/ .el-select .el-input .el-select__caret.is-reverse {
		transform: rotateZ(0) translateY(-7px) !important;
	}

	// /deep/ .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--date {
	//   height: 32px !important;
	// }

	/deep/.el-range-input {
		background: #fafbfc;
	}

	/deep/.el-date-editor .el-range__icon {
		line-height: 26px;
	}

	/deep/.el-date-editor .el-range-separator {
		line-height: 26px;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		border-color: #E71D43;
		background: #E71D43;
	}

	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #E71D43;
	}

	.numberOptions:nth-child(n + 3) {
		display: inline-block;
		position: relative;
		margin-left: 50px;
	}

	.numberOptions {
		display: inline-block;
		position: relative;

		.NumberLine {
			width: 16px;
			height: 2px;
			background: #e5e6eb;
			border-radius: 0px 0px 0px 0px;
			position: absolute;
			top: 50%;
			left: 110%;
		}
	}

	.numberOptions:nth-last-child(1) {
		display: inline-block;
		position: relative;

		.NumberLine {
			width: 16px;
			height: 2px;
			background: transparent;
			border-radius: 0px 0px 0px 0px;
			position: absolute;
			top: 50%;
			left: 110%;
		}
	}

	input,
	textarea {
		border: 1px solid #e6e8eb;
		background-color: #FFFFFF;
		font-size: 14px;
		color: #16181a;
		border-radius: 2px;
		padding-left: 10px;
		margin-top: 6px;
	}

	input::-webkit-input-placeholder,
	textarea::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #9ca5b8;
	}

	input:-moz-placeholder,
	textarea::-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #9ca5b8;
	}

	input::-moz-placeholder,
	textarea::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #9ca5b8;
	}

	input:-ms-input-placeholder,
	textarea::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #9ca5b8;
	}

	/deep/.el-input__inner:focus {
		transition: all 0.8s;
		border: 1px solid #e71d43;
	}

	input:focus,
	textarea:focus {
		transition: all 0.8s;
		border: 1px solid #e71d43;
	}

	textarea {
		padding: 6px !important;
	}

	.upload {
		display: inline-block;
		user-select: none;
		text-align: center;
		line-height: 32px;
		border-radius: 2px;
		border: 1px solid #e6e6e6;
		padding-left: 5px;
		padding-right: 5px;
		cursor: pointer;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #e71d43;
	}

	/* .redborder {
		/deep/.el-input__inner {
			border: 2px solid #e6e8eb;
		}

		/deep/.el-input.is-disabled .el-input__inner {
			border-color: #E4E7ED !important;
		}
	} */
</style>